export default "__VITE_ASSET__qa8MhJEf__"